module.exports = __webpack_public_path__ + "svg/capricorn.svg?a76d1bcf81675c874f2b17aa0ad27c05";